import { create } from "zustand";

import axios from "../helper/axios";

const useSourcingStore = create((set,get) => ({
    sourcingDetails: [],
    sourcingDetailsJd:[],
    sourcingDetailsTotalCount:0,

    sourcingDetailsNuJobs: [],
    sourcingDetailsJdNuJobs:[],
    sourcingDetailsTotalCountNuJobs:0,
    
    sourcingDetailsAutomation: [],
    sourcingDetailsJdAutomation:[],
    sourcingDetailsTotalCountAutomation:0,    

    nuJobsAllApplications: [],  
    nuJobsAllResumesTotalCount:0,    

    getSourcingDetails: async (data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getSourcingDetails/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           console.log(response.data.name); 
           //console.log(response.data.data);
           //console.log(response.data.jdData);
           //console.log(response.data.totalCount);
           set({ sourcingDetails: response?.data.data });
           set({ sourcingDetailsJd: response?.data.jdData });
           set({ sourcingDetailsTotalCount: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },   
    getSourcingDetailsNuJobs: async (data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getSourcingDetailsNuJobs/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           console.log(response.data.name); 
           //console.log(response.data.data);
           //console.log(response.data.jdData);
           //console.log(response.data.totalCount);
           set({ sourcingDetailsNuJobs: response?.data.data });
           set({ sourcingDetailsJdNuJobs: response?.data.jdData });
           set({ sourcingDetailsTotalCountNuJobs: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },
    getSourcingDetailsAutomation: async (data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getSourcingDetailsAutomation/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           console.log(response.data.name); 
           //console.log(response.data.data);
           ///console.log(response.data.jdData);
           //console.log(response.data.totalCount);
           set({ sourcingDetailsAutomation: response?.data.data });
           set({ sourcingDetailsJdAutomation: response?.data.jdData });
           set({ sourcingDetailsTotalCountAutomation: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },    

    getNuJobsAllResumes: async (data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getNuJobsAllResumes/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           console.log(response.data.name); 
           //console.log(response.data.data);         
           //console.log(response.data.totalCount);
           set({ nuJobsAllApplications: response?.data.data });
           set({ nuJobsAllResumesTotalCount: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    }, 
}));



export default useSourcingStore;
